/* @flow */

export const slickSliderSettings = {
  dots: false,
  infinite: true,
  slidesToScroll: 1,
  autoplaySpeed: 3000
}
